import { AnyAaaaRecord } from "dns";
import { IUserData } from "../User/IUserData";
import { IBaseAxiosResponse } from "../Helper/IAxios";

export interface INotification {
  Action: NotificationActionEnum;
  ConstructionSite: AnyAaaaRecord;
  ConstructionSiteFk: number;
  Content: IContent[];
  CreatedByUser: IUserData;
  CreationDate: Date;
  IsRead: boolean;
  Message: string;
  PersonalMessage?: string;
  NotificationId: string;
  Type: NotificationTypeEnum;
  ItemId: string;
  ItemAuxId: string;
  IsTargeted?: boolean;
  TargetUsers?: ITargetUsers[];
  AggNotificationIds?: string[];
  ItemUrl?: string;
  Source: NotificationSourceEnum;
  Data?: string;
}

export interface INotificationData {
  Description?: string;
  From?: string;
  To?: string;
  Filename?: string;
  CreatedByUserFk?: string;
}

export interface ITargetUsers {
  NotificationFk: string;
  UserFk: string;
  IsPersonal: boolean;
}

export interface INotificationAxiosResponse {
  info: any;
  data: INotification[];
  success: boolean;
}

export interface IContent {
  Type: NotificationContentTypeEnum;
  Class: string | null;
  ContentItems: IContentItem[];
  // For UI multiple implementation
  aggIds?: string[];
}

export interface IContentItem {
  id?: number | string;
  icon?: string;
  value?: string;
  label?: string;
  oldValue?: string;
  oldValueClass?: string;
  newValue?: string;
  newValueClass?: string;
  url?: string;
  date?: Date;
  valueClass?: string;
  hasAvatar?: boolean;
  iconFooter?: string;
  dueDate?: Date;
}

export enum NotificationTypeEnum {
  File = 1,
  Activity = 2,
  Plotting = 3,

  // Temporary
  ConstructionSite = 4,
  Invite = 5,
}

export enum NotificationSourceEnum {
  User = 0,
  System = 1,
}

export enum NotificationActionEnum {
  FileCreated = 1,
  FileDeleted = 2,
  FileMoved = 3,
  FileVersionAdded = 4,
  FileStatusChanged = 12,
  FileRenamed = 13,
  FileDescriptionUpdated = 14,
  FileCreatedObsolet = 19,
  FileRendered = 22,
  FolderCreated = 5,
  FolderRenamed = 23,
  FolderDeleted = 24,

  TopicCreated = 6,
  TopicUpdated = 7,
  TopicStatusChanged = 8,
  TopicDeleted = 9,
  TopicAttachmentAdded = 10,
  TopicAttachmentDeleted = 11,
  TopicCommentAdded = 20,
  TopicExpiresTommorow = 30,
  TopicExpiresToday = 31,
  TopicExpiredYesterday = 32,

  PlottingCreated = 15,
  PlottingStatusChanged = 16,
  PlottingFileDeleted = 17,
  PlottingRequestDeleted = 18,
  PlottingCreatedObsolet = 21,

  DisciplineCreated = 25,
  DisciplineDeleted = 26,
  DisciplineRenamed = 27,
  DisciplineDisconnected = 28,
  DisciplineReconnected = 29,
}

export const listFoldersAndFilesActions: NotificationActionEnum[] = [
  NotificationActionEnum.FileCreated,
  NotificationActionEnum.FileDeleted,
  NotificationActionEnum.FileMoved,
  NotificationActionEnum.FileVersionAdded,
  NotificationActionEnum.FileStatusChanged,
  NotificationActionEnum.FileRenamed,
  NotificationActionEnum.FileDescriptionUpdated,
  NotificationActionEnum.FileCreatedObsolet,
  NotificationActionEnum.FileRendered,
  NotificationActionEnum.FolderCreated,
  NotificationActionEnum.FolderRenamed,
  NotificationActionEnum.FolderDeleted,
];

export const listActivitiesActions: NotificationActionEnum[] = [
  NotificationActionEnum.TopicCreated,
  NotificationActionEnum.TopicUpdated,
  NotificationActionEnum.TopicStatusChanged,
  NotificationActionEnum.TopicDeleted,
  NotificationActionEnum.TopicAttachmentAdded,
  NotificationActionEnum.TopicAttachmentDeleted,
  NotificationActionEnum.TopicCommentAdded,
  NotificationActionEnum.TopicExpiresTommorow,
  NotificationActionEnum.TopicExpiresToday,
  NotificationActionEnum.TopicExpiredYesterday,
];

export const listPlottingActions: NotificationActionEnum[] = [
  NotificationActionEnum.PlottingCreated,
  NotificationActionEnum.PlottingStatusChanged,
  NotificationActionEnum.PlottingFileDeleted,
  NotificationActionEnum.PlottingRequestDeleted,
  NotificationActionEnum.PlottingCreatedObsolet,
];

export const listDisciplinesActions: NotificationActionEnum[] = [
  NotificationActionEnum.DisciplineCreated,
  NotificationActionEnum.DisciplineDeleted,
  NotificationActionEnum.DisciplineRenamed,
  NotificationActionEnum.DisciplineDisconnected,
  NotificationActionEnum.DisciplineReconnected,
];

export const listActionsGoToFileViewer: NotificationActionEnum[] = [
  NotificationActionEnum.FileCreated,
  NotificationActionEnum.FileDeleted,
  NotificationActionEnum.FileMoved,
  NotificationActionEnum.FileVersionAdded,
  NotificationActionEnum.FileStatusChanged,
  NotificationActionEnum.FileRenamed,
  NotificationActionEnum.FileDescriptionUpdated,
  NotificationActionEnum.FileCreatedObsolet,
  NotificationActionEnum.FileRendered,
];

export const listActionsGoToPath: NotificationActionEnum[] = [
  NotificationActionEnum.FolderCreated,
  NotificationActionEnum.FolderRenamed,
  NotificationActionEnum.FolderDeleted,
  NotificationActionEnum.DisciplineCreated,
  NotificationActionEnum.DisciplineDeleted,
  NotificationActionEnum.DisciplineRenamed,
  NotificationActionEnum.DisciplineDisconnected,
  NotificationActionEnum.DisciplineReconnected,
];

export enum NotificationContentTypeEnum {
  ref = 'ref',
  valueChanged = 'valueChanged',
  images = 'images',
  textbox = 'textbox',
  date = 'date',
}

export interface INewNotificationsCountRequest {
  constructionSiteId?: number | null;
  personalOnly?: boolean;
}

export interface INewNotificationsRequest {
  constructionSiteId?: number | null;
  personalOnly?: boolean;
  pageNumber?: number;
  pageSize?: number;
  filters?: INewNotificationsFilters;
}

export interface INewNotificationsFilters {
  authorIds?: string[];
  actions?: number[];
  csIds?: number[];
  creationDateFrom?: Date | string;
  creationDateTo?: Date | string;
  isRead?: boolean;
}

export interface INewNotificationsResponse {
  notifications: INotification[];
  total: number;
  pageNumber: number;
  pageSize: number;
}

export interface INewNotificationsAxiosResponse {
  info: INotificationInfo;
  data: INotification[];
  success: boolean;
}

export interface INotificationInfo {
  pageSize: number;
  currentPageNumber: number;
  nextPageNumber: number | null;
}

export interface INotificationCountResponse {
  count: number;
}

export interface INotificationCountAxiosResponse {
  info: any;
  data: INotificationCountResponse;
  success: boolean;
}

export interface INotificationReadRequest {
  constructionSiteId: number;
  notificationId: string;
  aggIds?: string[];
  itemAuxId?: string;
  filters?: INewNotificationsFilters;
}

export interface INotificationMultipleReadRequest {
  constructionSiteId: number;
  notificationIds: string[];
  itemAuxId?: string;
  filters?: INewNotificationsFilters;
}

export interface INotificationReadAllRequest {
  constructionSiteId?: number | null;
  filters?: INewNotificationsFilters;
}

export interface INotificationInfinityData {
  notifications: INotification[];
  info: INotificationInfo;
}

export interface INotificationReadActivity {
  activityId: string;
  readData: Record<string, INotificationMultipleReadRequest>;
}

export const filterItemIdByActivityAction = [
  NotificationActionEnum.TopicCreated,
  NotificationActionEnum.TopicUpdated,
  NotificationActionEnum.TopicStatusChanged,
  NotificationActionEnum.TopicDeleted,
];

export const filterItemAuxIdByActivityAction = [
  NotificationActionEnum.TopicAttachmentAdded,
  NotificationActionEnum.TopicAttachmentDeleted,
  NotificationActionEnum.TopicCommentAdded,
];

export interface INotificationInAppObra {
  NotificationId: string;
  Type: NotificationTypeEnum;
  Action: NotificationActionEnum;
  ItemId: string;
  Folders: string[];
}

export interface INotificationInAppObraAxiosResponse extends IBaseAxiosResponse<INotificationInAppObra[]> { }

export interface INotificationInAppObraCount {
  ConstructionSiteId: number;
  Count: number;
}

export interface INotificationInAppObrasAxiosResponse extends IBaseAxiosResponse<INotificationInAppObraCount[]> { }

export interface INotificationAsView {
  key: string;
  data: INotificationReadRequest[];
}

export interface INotificationInAppTopicsAxiosResponse extends IBaseAxiosResponse<INotificationInAppTopic[]> { }

export interface INotificationInAppTopic {
  TopicId: string;
  NotificationIds: string[] | null;
  HasCommentUnread: boolean;
}

export const actionsOnlyToAdminOrCoordinator = [
  NotificationActionEnum.FileCreatedObsolet,
  NotificationActionEnum.PlottingCreatedObsolet,
]

export const actionsOnlyToPlotting = [
  NotificationActionEnum.PlottingCreated,
  NotificationActionEnum.PlottingStatusChanged,
  NotificationActionEnum.PlottingFileDeleted,
  NotificationActionEnum.PlottingRequestDeleted,
  NotificationActionEnum.PlottingCreatedObsolet,
]
